import { render, staticRenderFns } from "./Pricelists.vue?vue&type=template&id=89fc8eb0&scoped=true&"
import script from "./Pricelists.vue?vue&type=script&lang=js&"
export * from "./Pricelists.vue?vue&type=script&lang=js&"
import style0 from "./Pricelists.vue?vue&type=style&index=0&id=89fc8eb0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89fc8eb0",
  null
  
)

export default component.exports